import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Kinetic({ lines, as: Tag = "h1", className = "", delay = 0, inView = false }) {
  const trigger = inView
    ? { initial: "hidden", whileInView: "visible", viewport: { once: true, amount: 0.2 } }
    : { initial: "hidden", animate: "visible" };
  return (
    <Tag className={className}>
      {lines.map((node, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden pb-[0.06em] -mb-[0.06em]"
          {...trigger}
        >
          <motion.span
            className="block will-change-transform"
            variants={{ hidden: { y: "112%" }, visible: { y: "0%" } }}
            transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.11 }}
          >
            {node}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
}

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, light = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-[11px] font-sans uppercase tracking-[0.28em] ${
        light ? "text-paper/60" : "text-fog"
      } ${className}`}
    >
      <span className={`h-px w-8 ${light ? "bg-paper/40" : "bg-sanddeep"}`} />
      {children}
    </span>
  );
}

export function ParallaxImg({ src, alt, className = "", amount = 9 }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${amount}%`, `${amount}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className="h-full w-full object-cover will-change-transform"
        loading="lazy"
      />
    </div>
  );
}
